export const SET_FILTERS = "SET_FILTERS";

export const setFilters = (filters) => ({
  type: SET_FILTERS,
  payload: {
    filters,
  },
});
